import axios from 'axios'

const MY_REGION_ENDPOINT = 'https://your-region.agribus-connect.net'

class ConnectMyRegionClient {
  getMyRegion() {
    return axios
      .create({
        baseURL: MY_REGION_ENDPOINT,
        headers: {
          'Content-Type': 'text/html',
          'Access-Control-Allow-Origin': '*',
        },
        responseType: 'text',
      })
      .get(MY_REGION_ENDPOINT)
  }
}

const connectMyRegionClient = new ConnectMyRegionClient()
export default connectMyRegionClient
